import styled from 'styled-components';

export const EWarrantyDepCodeContainerStyled = styled.div``;
